import React from "react";
import { Link } from "react-router-dom";
import { Download, BookOpen, Newspaper, ArrowRight, Calendar } from "lucide-react";
import { catalogs, news } from "../mock";

export const Catalogs = () => (
  <section className="py-20 bg-[#0B2545] text-white relative overflow-hidden">
    <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#00A859]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
    <div className="max-w-[1400px] mx-auto px-6 relative">
      <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
        <div>
          <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">
            <BookOpen className="w-4 h-4 inline mr-2 -mt-1" />
            Cataloghi
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight">
            Sfoglia i nostri cataloghi
          </h2>
          <p className="text-gray-300 mt-3 max-w-2xl">
            Selezione accurata dei prodotti, schede tecniche dettagliate e tutte
            le informazioni di cui hai bisogno.
          </p>
        </div>
        <Link
          to="/cataloghi"
          className="inline-flex items-center gap-2 text-[#00A859] font-bold uppercase text-sm tracking-wide hover:gap-3 transition-all"
        >
          Tutti i cataloghi <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
        {catalogs.map((c) => (
          <div
            key={c.id}
            className="group bg-white/5 hover:bg-white/10 backdrop-blur-sm border border-white/10 hover:border-[#00A859] rounded-2xl overflow-hidden transition-all duration-300"
          >
            <div className="aspect-[3/4] overflow-hidden bg-gray-800">
              <img
                src={c.cover}
                alt={c.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <h3 className="font-bold text-base mb-1 leading-tight">{c.title}</h3>
              <p className="text-xs text-gray-400 mb-3">{c.pages} pagine</p>
              <button className="w-full inline-flex items-center justify-center gap-2 bg-[#00A859] hover:bg-[#00874A] text-white font-bold text-xs uppercase tracking-wide px-4 py-2.5 rounded-full transition-colors">
                <Download className="w-3.5 h-3.5" /> Sfoglia
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const News = () => (
  <section className="py-20 bg-gray-50">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
        <div>
          <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">
            <Newspaper className="w-4 h-4 inline mr-2 -mt-1" />
            News & Novità
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B2545] tracking-tight">
            Ultime dal blog
          </h2>
        </div>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 text-[#00A859] font-bold uppercase text-sm tracking-wide hover:gap-3 transition-all"
        >
          Tutte le news <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {news.map((n) => (
          <article
            key={n.id}
            className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={n.image}
                alt={n.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3 text-xs text-gray-500">
                <span className="bg-[#00A859]/10 text-[#00A859] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
                  {n.category}
                </span>
                <span className="flex items-center gap-1">
                  <Calendar className="w-3.5 h-3.5" /> {n.date}
                </span>
              </div>
              <h3 className="text-lg font-bold text-[#0B2545] mb-2 leading-tight group-hover:text-[#00A859] transition-colors">
                {n.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                {n.excerpt}
              </p>
              <Link
                to="/news"
                className="text-[#00A859] font-bold text-sm uppercase tracking-wide inline-flex items-center gap-1.5 hover:gap-2.5 transition-all"
              >
                Leggi di più <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
